import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useApp } from '../../../context/AppContext';
// import './form_login.css';

function FormLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useApp();

  useEffect(() => {


    const prefillPassword = sessionStorage.getItem('prefillPassword');
    const prefillEmail = sessionStorage.getItem('prefillEmail') || localStorage.getItem('userEmail');


    if (prefillPassword) {
      setPassword(prefillPassword);
      sessionStorage.removeItem('prefillPassword');
    }


    if (prefillEmail) {
      setEmail(prefillEmail);
      sessionStorage.removeItem('prefillEmail');
      localStorage.removeItem('userEmail');
    }


  }, [location.key]);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=login&email=${email}&password=${password}`, { credentials: 'include' });
        const data = await response.json();



        if (data.status === 0) {
          const params = new URLSearchParams(location.search);
          const redirect = params.get('redirect') || localStorage.getItem('redirectAfterLogin') || '/dashboard';
          localStorage.removeItem('redirectAfterLogin');
          login({ ID_usuario: data.ID_usuario, nome: data.nome }, () => navigate(redirect, { state: { fromLogin: true } }));




        } else {
            setErrorMessage('Login falhou. Cheque suas credenciais.');
        }
    } catch (error) {

        console.error('Erro ao logar: ', error);
        setErrorMessage('Um erro ocorreu. Tente novamente mais tarde.');

    }
  };

  return (
    <form onSubmit={handleLogin}>
      <Link to="/login" className="no-link-style">
        <img src="https://rveducacao.com.br/230616_RV_logo_principal_positivo-cor.png" alt="Logo" className='login-logo' />
      </Link>
      <input type="text" placeholder="Email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <input type="password" placeholder="Senha" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      <button className='button' type="submit"> Entrar </button>
      <Link to="/esqueciasenha" className='no-link-style'>
        <div className="link-cadastro">Esqueci a Senha</div>
      </Link>
    </form>
  );
}

export default FormLogin;
